import { StrictMode, startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { Await, RouterProvider } from "@tanstack/react-router";
import { hydrateStart } from "@tanstack/react-start/client";
import { BProgress } from "@bprogress/core";
import {
  addClientSentryRouterTracing,
  initializeClientSentry,
} from "./instrumentation-client";
import { sentryReactErrorHandlers } from "./lib/report-react-error";

initializeClientSentry();

const hydrationPromise = hydrateStart().then((router) => {
  addClientSentryRouterTracing(router);

  router.subscribe("onBeforeLoad", (event) => {
    const fromPath = event?.fromLocation?.pathname;
    const toPath = event?.toLocation?.pathname;

    // 1. If we don't have a previous path (like initial page load), don't trigger it
    if (!fromPath) return;

    // 2. ONLY trigger if the actual pathname is different
    if (fromPath !== toPath) {
      BProgress.start();
    }
  });
  router.subscribe("onResolved", () => {
    BProgress.done();
  });

  return router;
});

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <Await promise={hydrationPromise}>
        {(router) => <RouterProvider router={router} />}
      </Await>
    </StrictMode>,
    sentryReactErrorHandlers,
  );
});
